import React from 'react';
import { ArrowUpRight, BarChart3, Sprout, Settings } from 'lucide-react';
import './Work.css';

import { motion } from 'framer-motion';

const Work = () => {
  const projects = [
    {
      name: 'Nexus Analytics',
      tag: 'FINTECH',
      problem: 'Startups struggled to track complex financial metrics across multiple fragmented payment platforms.',
      solution: 'A unified dashboard that aggregates data from Stripe, PayPal, and banks into a single real-time source of truth.',
      outcome: 'Reduced reporting time by 80% and helped 50+ startups secure their next funding round.',
      stack: ['Next.js', 'PostgreSQL', 'Stripe API'],
      color: 'linear-gradient(135deg, #ff4c00, #f59e0b)',
      icon: <BarChart3 size={80} strokeWidth={1} />
    },
    {
      name: 'EcoFlow Supply',
      tag: 'LOGISTICS',
      problem: 'High waste and inefficient routing in organic supply chains were draining margins and increasing carbon footprints.',
      solution: 'An AI-powered route optimization engine with real-time tracking for perishable goods.',
      outcome: '15% reduction in fuel costs and zero reported spoilage over 12 months of operation.',
      stack: ['React', 'Node.js', 'Google Maps API'],
      color: 'linear-gradient(135deg, #f97316, #ef4444)',
      icon: <Sprout size={80} strokeWidth={1} />
    },
    {
      name: 'Streamline ERP',
      tag: 'MANUFACTURING',
      problem: 'Manual inventory management led to frequent production delays and overstocking issues.',
      solution: 'Automated inventory tracking system with predictive reordering based on historical demand.',
      outcome: '40% increase in production efficiency and a $200k reduction in annual overstock waste.',
      stack: ['Vue.js', 'Python', 'AWS'],
      color: 'linear-gradient(135deg, #ea580c, #9a3412)',
      icon: <Settings size={80} strokeWidth={1} />
    }
  ];

  return (
    <section className="work" id="work">
      <div className="work-container">
        <motion.div 
          className="work-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Success Stories</h2>
          <p className="section-subtitle">Real-world problems solved with precision engineering.</p>
        </motion.div>

        <motion.div 
          className="work-list"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          {projects.map((project, idx) => (
            <div key={idx} className="project-item">
              <div className="project-preview" style={{ background: project.color }}>
                <div className="project-icon">{project.icon}</div>
              </div>
              <div className="project-details">
                <div className="project-tag">{project.tag}</div>
                <h3 className="project-name">{project.name}</h3>
                
                <div className="project-brief">
                  <div className="brief-item">
                    <span className="brief-label">Problem</span>
                    <p className="brief-text">{project.problem}</p>
                  </div>
                  <div className="brief-item">
                    <span className="brief-label">Solution</span>
                    <p className="brief-text">{project.solution}</p>
                  </div>
                  <div className="brief-item">
                    <span className="brief-label">Outcome</span>
                    <motion.p 
                      className="brief-text outcome-highlight"
                      initial={{ backgroundSize: '0% 100%' }}
                      whileInView={{ backgroundSize: '100% 100%' }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.8, delay: 0.5 }}
                    >
                      {project.outcome}
                    </motion.p>
                  </div>
                </div>

                <div className="project-footer">
                  <div className="project-stack">
                    {project.stack.map((stk, i) => (
                      <span key={i} className="stack-pill">{stk}</span>
                    ))}
                  </div>
                  <button className="project-link">
                    Explore Case Study
                    <ArrowUpRight size={18} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Work;
